import { Loader as Spinner } from '@wheely/ui-kit';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';

import s from './Loader.module.css';

const Loader = ({ className, isStatic = false }: { className?: string; isStatic?: boolean }) => (
  <div className={cn(s.loader, className, { [s.static]: isStatic })}>
    <Spinner className={s.spinner} />
    <div className={s.label}>
      <FormattedMessage defaultMessage="Loading" id="k2qnb9" description="Loading indicator" />
    </div>
  </div>
);

export { Loader };
